import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 border-2 border-brand border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/panel" replace />;
  return children;
}
